import { JSX } from 'react';
import { TodoTask } from '../../todolist/add-todo/addTodoList';
import {categoryOptions} from '../../todolist/category/category';
import CheckBox from './checkBox/checkBox';
import TodoManager from '../../todolist/data/todoManager';
import './todoTaskView.css';

const TodoTaskView = ({todo, onUpdate}:{todo:TodoTask, onUpdate:() => void}): JSX.Element => {
    const todoManager = TodoManager.getInstance();
    
    const changeComplete = async (isComplete: boolean) => {
        try {
            await todoManager.updateTodoComplete(todo, isComplete);
            onUpdate();
        } catch (error) {
            console.error('Failed to update todo:', error);
        }
    };

    return (
        <div className='todo-task-view'>
            <CheckBox isCompleted={todo.completed} onCompleteChange={changeComplete}/>
            <p className={`todo-task-title ${todo.completed ? 'completed' : ''}`}>{todo.title}</p>
            <img src={categoryOptions.find(option => option.type === todo.category).image} className='todo-preview-category-img'/>
        </div>
    ); 
};
  
export default TodoTaskView;
